import style from "../style/politica.module.css";

export default function Politica() {
  return (
    <main className={style.container}>
      <section className={style.card}>
        <h2 className={style.title}>Política de Privacidade</h2>
        <p className={style.content}>
          As informações que serão inseridas pelo usuário servirão
          exclusivamente para cálculos financeiros disponibilidados no{" "}
          <strong>OrgFin </strong>sem armazenamento em base de dados,servidor ou
          qualquer armazenamento permanente. Nesse Sentido, assim que a página
          for atualizada ou fechada, todas as informações inseridas serão
          apagadas, por que o site não possui o sistema de autenticação e
          cadastro,<strong>neste contexto</strong>, todas as informações serão
          processadas durante o uso da página.
        </p>
      </section>
      <section className={style.card}>
        <h2 className={style.title}>Termos de Uso</h2>
        <p className={style.content}>
          <ul className={style.tip}>
            <li>
              O objetivo do OrgFin é auxiliar o usuário na organização
              financeira, permitindo o registro de receitas e despesas para
              estimar saldo projetado. A ferramenta permite usar a receita como
              referência para visualizar o quanto restará de seu saldo após
              considerar as despesas informadas,assim o usuário pode registrar
              quantas receitas e despesas simular em diferentes contextos ou
              cenários.
            </li>
            <li>
                Os resultados apresentados pelo <strong>OrgFin</strong> têm
                caráter consultivo e estimativo. O usuário é responsável pelas
                decisões financeiras tomadas após inserção das informações no
                sistema baseado nos cálculos realizados. O OrgFin não apresenta
                consultoria financeira,contábil ou jurídica.
            </li>
          </ul>
        </p>
      </section>
    </main>
  );
}
